import { JsCarousel } from '../../components/carousels/JsCarousel';
import { CollectionHubCarouselTracking } from './tracking/CollectionHubCarouselTracking';
import { GenericCarouselTracking } from './tracking/GenericCarouselTracking';
import { BrandsCarouselTracking } from './tracking/BrandsCarouselTracking';
import { ListCarouselTracking } from './tracking/ListCarouselTracking';
import { YouMightAlsoLikeCarouselTracking } from './tracking/YouMightAlsoLikeCarouselTracking';
import { ExtrasCarouselTracking } from './tracking/ExtrasCarouselTracking';
import { NewsCarouselTracking } from './tracking/NewsCarouselTracking';
import { trackAction } from 'helpers/trackingOM';

// START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
import {
    initializePreviousSearchInstance,
    trackRecentSearchCarousel,
} from 'abTests/testClasses/SearchPagePreviousSearch';
import appendSpotlightTracking from './spotlightTracking';
// END A/B TEST PLGRWEB-1647-SearchPage-Previous Searches

const MOVIES_TEXT = 'movies';

// START AB TEST PLGRWEB-307-SEARCHSCREEN-CAROUSEL
const searchPageCarouselVariants = [
    'test-_web_carousel_test_on_search-hybrid_showmovie_onnow',
    'test-_web_carousel_test_on_search-movies_shows_onnow',
    'test-_web_carousel_test_on_search-personalized_by_hpconfig',
];
// END AB TEST PLGRWEB-307-SEARCHSCREEN-CAROUSEL

export class JsCarouselTracking {
    /**
     *
     * @type {HTMLElement}
     */
    element = null;
    /**
     *
     * @type {JsCarousel}
     * @private
     */
    #carousel = null;

    /**
     *
     * @type {string}
     * @private
     */
    #title = '';

    /**
     *
     * @type {{CBSNews: NewsCarouselTracking, YouMightAlsoLike: YouMightAlsoLikeCarouselTracking, collectionHubCarousel: CollectionHubCarouselTracking, Brands: BrandsCarouselTracking, MyList: ListCarouselTracking, WatchList: ListCarouselTracking}}
     * @private
     */
    #parsers = {
        collectionHubCarousel: CollectionHubCarouselTracking,
        CBSNews: NewsCarouselTracking,
        Brands: BrandsCarouselTracking,
        MyList: ListCarouselTracking,
        WatchList: ListCarouselTracking,
        YouMayAlsoLike: YouMightAlsoLikeCarouselTracking,
        Extras: ExtrasCarouselTracking,
    };

    /**
     *
     * @param elem {HTMLElement}
     * @param caro { JsCarousel }
     */
    constructor(elem, caro) {
        if (!elem.hasAttribute('has-tracking-listeners')) {
            elem.setAttribute('has-tracking-listeners', 'true');
            this.element = elem;
            this.#carousel = caro;
            this._init();
        }
    }

    /**
     *
     * @private
     */
    _init() {
        const body = document.getElementsByTagName('body')?.[0];
        this._waitForSwiper();
    }

    /**
     * @private
     */
    _waitForSwiper() {
        if (this.#carousel.options.data) {
            this._addListeners();
            this.#carousel?.swiper?.on('slideNextTransitionEnd', () => {
                this._addListeners();
            });
        } else {
            this.#carousel.getWrapper().on('videoDataRendered', () => {
                this._addListeners();
                this.#carousel?.swiper?.on('slideNextTransitionEnd', () => {
                    this._addListeners();
                });
            });
        }
    }

    /**
     *
     * @param _data
     * @returns {string}
     */
    _getCarouselType(_data) {
        if (CBS.Registry.news) {
            return 'CBSNews';
        }
        if (Array.isArray(_data) && _data?.at(0) === 'collectionHubCarousel') {
            return _data.at(0);
        }
        return this.#title.replace("'", '').replace(/\s/g, '').replace('', '').trim();
    }

    _getCarouselNum(activeTitle) {
        activeTitle = activeTitle.toLowerCase();
        let carousel_num = 0;
        const videoTitles = document.querySelectorAll('.video-section-title');

        videoTitles.forEach((elem, index) => {
            const otLoop = elem.textContent
                .replace("'", '')
                .replace(/\s/g, '')
                .replace('', '')
                .trim();
            if (otLoop.toLowerCase() === activeTitle) {
                carousel_num = index + 1;
            }
        });
        return carousel_num;
    }

    getCurrentPageRowPosition() {
        const $item = $(this.element);
        const $items = $('.hero__wrapper, .js-le-carousel, .grid-view');

        let $itemMainParent = $item.parents('.js-le-carousel');
        if ($itemMainParent.length === 0) {
            $itemMainParent = $item.parents('.grid-view');
        }

        let position = $items.index($itemMainParent);

        return position?.toString();
    }

    _getCarouselTitle() {
        const $title = this.element.querySelector('h2.video-section-title')?.textContent;
        return $title.replace("'", '').replace(/\s/g, '').replace('', '').trim();
    }
    /**
     *
     */
    _addListeners() {
        this.#title =
            this.element.closest('.carousel')?.querySelector('h2.video-section-title')
                ?.textContent ?? '';

        const links = this.element?.querySelectorAll('a.link');
        if (links && links.length > 0) {
            links.forEach((elem) => {
                if (elem.hasAttribute('has-tracking-listeners')) {
                    return;
                }
                elem.setAttribute('has-tracking-listeners', 'true');
                let data = elem.getAttribute('aa-link');
                let dd = data?.split('|') ?? [];
                let contentTitle = elem
                    .querySelector('.info-wrapper .title-wrapper .title')
                    ?.textContent?.trim();
                let contentTitleArray = contentTitle?.split('|');
                let fathom = elem?.dataset?.fathom?.split('|') ?? [];
                let aalink = [];

                if (contentTitleArray?.length > 1) {
                    dd.forEach((item, index) => {
                        aalink.push(item.toString());
                    });
                } else {
                    aalink = data?.split('|') ?? [];
                }
                elem.addEventListener('click', (e) => {
                    if (e.target.tagName == 'INPUT' || e.target.tagName == 'LABEL') return;

                    const carouselType = this._getCarouselType(aalink);
                    const carouselNum = this.getCurrentPageRowPosition();
                    let obj;

                    // START AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel
                    let carouselCycle;
                    if (this.#carousel.continuousEndScroll) {
                        carouselCycle = this.#carousel.continuousEndScroll
                            .getCarouselCycle(elem)
                            .toString();
                        aalink.push(`carouselCycle:${carouselCycle}`);
                    }
                    // END AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel

                    const YOU_MAY_ALSO_LIKE = 'YouMayAlsoLike';
                    const isThumbHasAddToMyListExperiment = () => {
                        return (
                            carouselType === YOU_MAY_ALSO_LIKE &&
                            e.target.classList.contains('watchlist_copy')
                        );
                    };
                    if (isThumbHasAddToMyListExperiment()) {
                        return;
                    }

                    // START A/B TEST PLGRWEB-1649-add to my list button from my list page
                    const isThumbHasAddToMyListPagexperiment = () => {
                        const carouselTitle = 'Recommended Based on My List';
                        return (
                            this.#title.trim() === carouselTitle &&
                            CBS?.AbTestsConfigs?.modules?.MyListPageAddToMyList?.inVariants &&
                            e.target.classList.contains('watchlist_copy')
                        );
                    };
                    if (isThumbHasAddToMyListPagexperiment()) {
                        return;
                    }
                    // END A/B TEST PLGRWEB-1649-add to my list button from my list page

                    if (this.#parsers.hasOwnProperty(carouselType)) {
                        obj = new this.#parsers[carouselType](
                            aalink,
                            fathom,
                            this.element,
                            carouselNum,
                            elem,
                        ).parse();
                    } else {
                        obj = new GenericCarouselTracking(
                            aalink,
                            fathom,
                            this.element,
                            carouselNum,
                            elem,
                        ).parse();
                    }
                    if (obj.carouselId?.includes('avatar-carousel')) {
                        return;
                    }

                    if (obj !== false) {
                        // START AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel
                        if (carouselCycle) {
                            obj.slideCycle = carouselCycle;
                        }
                        // END AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel

                        window.localStorage.setItem('metadata-video-tracking', JSON.stringify(obj));
                        let loc = window.location.href;
                        let action =
                            loc.indexOf('shows') > -1 ? 'trackShowContent' : 'trackRowHeader';
                        let href = elem.getAttribute('href');
                        let pageType =
                            utag_data.pageType ?? (href.indexOf('shows') > -1 ? 'show' : 'movie');
                        let contentLock = elem.parentElement.classList.contains('bundle-lock');
                        let firstSlide = elem.closest('.carousel-container').children[0];
                        const firstSlideAaLink =
                            elem
                                .closest('.js-le-carousel')
                                .querySelectorAll('.swiper-slide')[0]
                                ?.querySelector('a.link')
                                ?.getAttribute('aa-link')
                                ?.split('|') ?? [];

                        action =
                            CBS.Registry.pageType === 'hubs_collection' ||
                            loc.indexOf('/collections/') > -1
                                ? 'trackHubRowHeader'
                                : action;
                        obj.PPlusSubscriberBadge = CBS.Registry.user.id ? '0' : '1';

                        if (!CBS.Registry.homepage) {
                            if (CBS.Registry.videopage) {
                                if (CBS.Registry.Show.id != null) {
                                    action = 'trackShowContent';
                                } else if (CBS.Registry.livetv) {
                                    action = 'trackLiveVideoRowHeader';
                                } else {
                                    if (
                                        this._getCarouselType(aalink) === 'YouMightAlsoLike' ||
                                        this._getCarouselType(aalink) === 'Extras' ||
                                        CBS.Registry.MovieTitle != null
                                    ) {
                                        action = 'trackRowHeader';
                                    } else {
                                        action = 'trackVideoRowHeader';

                                        if (CBS.Registry.kidsLanding) {
                                            action = 'trackContentGridSelect';
                                            obj.posRowNum = '1';
                                            obj.posColNum = (Number(obj.posColNum) - 1).toString();
                                        }
                                    }
                                }
                            } else {
                                if (CBS.Registry.kidsLanding) {
                                    action = 'trackContentGridSelect';
                                    obj.posRowNum = '1';
                                    obj.posColNum = (Number(obj.posColNum) - 1).toString();
                                }

                                if (CBS.Registry.search) {
                                    action = 'trackSearchCarouselSelect';

                                    let $activePresearchLink = $('.subnav__items a.active');
                                    if ($activePresearchLink.length) {
                                        action = 'trackSearchResult';
                                        obj.suggestedSearchTerm = $.trim(
                                            $activePresearchLink.text(),
                                        );
                                    }

                                    obj.posRowNum = this.getCurrentPageRowPosition();

                                    // add pre-search suggestions to this track action
                                    obj.searchFilterInView = this.__getPreSearchSuggestionFilters();
                                }

                                if (
                                    CBS.Registry.brand.name === 'CBS' ||
                                    CBS.Registry.pageType == 'SHOWHOME'
                                ) {
                                    action = 'trackShowContent';
                                    obj.posRowNum = this.getCurrentPageRowPosition();
                                    obj.showSeriesId = aalink[11] ? aalink[11] : '';
                                    obj.pageType = pageType;
                                    obj.contentLocked = contentLock ? '1' : '0';
                                }

                                if (CBS.Registry.news) {
                                    action = 'trackNewsRowHeader';
                                }

                                if (CBS.Registry.mylist) {
                                    action = 'trackCarouselSelect';
                                    obj.posRowNum = this.getCurrentPageRowPosition();
                                }
                            }
                        }

                        if ($(this.element).parents('.kids-carousel').length) {
                            action = 'trackCharacterCarouselSelect';
                            obj.contentLocked = contentLock ? '1' : '0';
                            obj.carouselId = Number(aalink[2]).toString() ?? '';
                            obj.carouselContentType = aalink[6] ?? '';
                            obj.carouselModel = aalink[7] ?? '';
                            obj.carouselLink = elem?.getAttribute('href') ?? '';
                            obj.characterTitle = aalink[8] ?? '';
                            obj.contentBrand = utag_data?.contentBrand
                                ? utag_data.contentBrand
                                : 'na';
                            obj.characterFileName = String(aalink[4]) ?? '';
                            obj.carouselPresentationStyle = 'default';
                            obj.showSeriesTitle = '';
                            obj.showTitle = '';
                            obj.showSeriesId = '';
                            obj.showSeasonNumber = '';
                            obj.showEpisodeNumber = '';
                            obj.showEpisodeLabel = 'na';
                            obj.rowHeaderTitle = obj?.rowHeaderTitle ?? '';
                            obj.posRowNum = obj?.posRowNum ?? '';
                            obj.posColNum = obj?.posColNum ?? '';
                            obj.hubId = utag_data?.hubId ?? '';
                            obj.hubSlug = utag_data?.hubSlug ?? '';
                            obj.hubPageType = utag_data?.hubPageType ?? '';
                        } else {
                            action = CBS.Registry.homepage ? 'trackCarouselSelect' : action;
                        }

                        const newBadge = $(this).find('.new-item').text();
                        if (newBadge) {
                            obj = {
                                ...obj,
                                contentBadgeLabel: newBadge,
                                posRowNum: this.getCurrentPageRowPosition(),
                            };
                        }
                        window.localStorage.setItem('metadata-video-tracking', JSON.stringify(obj));
                        if (
                            aalink[0]?.toLowerCase().includes(MOVIES_TEXT) &&
                            obj.carouselContentType !== 'show'
                        ) {
                            let o = {
                                movieTitle: fathom[5],
                                movieId: aalink[16],
                                showGenre: '',
                            };
                            obj = {
                                ...obj,
                                ...o,
                            };
                            delete obj.showSeriesTitle;
                            delete obj.showSeriesId;
                        }

                        if (firstSlideAaLink.length >= 2 && firstSlideAaLink[1] === 'promoTile') {
                            action = 'trackPromoTileSelect';
                            obj = {
                                promoSpotTitle: firstSlideAaLink[0],
                                ctaText: aalink[2],
                                rowHeaderTitle: obj.rowHeaderTitle,
                                carouselId: obj.carouselId,
                                carouselContentType: 'promo_' + aalink[6],
                                carouselModel: obj.carouselModel,
                                carouselLink: obj.carouselLink,
                                posRowNum: obj.posRowNum,
                                posColNum: obj.posColNum,
                                hubId: aalink[5],
                                showSeriesId: aalink[16],
                                contentLocked: aalink[23],
                            };
                        }

                        // set promoSpotTitle on all carousel items in carousel that has a promo tile
                        let $promoInfo = $(this.element).find('.promoInfo');
                        if ($promoInfo.length) {
                            let promoAAlink =
                                $promoInfo.parents('a.link').attr('aa-link').split('|') ?? [];
                            obj.promoSpotTitle = promoAAlink[0];
                            if (aalink[1] !== 'promoTile') {
                                obj.posColNum = parseInt(obj.posColNum) + 1;
                            }
                        } else {
                            // set empty value in non promo tile having carousels
                            obj.promoSpotTitle = '0';
                        }

                        obj.carouselId = $(this.element)
                            .closest('.js-le-carousel')
                            .data('carouselid');

                        if (
                            obj.carouselModel === 'promotion' &&
                            obj.carouselPresentationStyle !== 'spotlight' &&
                            (aalink[15] === 'hub' || fathom[3] === 'hub')
                        ) {
                            action = 'trackCarouselSelect';
                            obj.hubId = aalink[16] ?? fathom[0] ?? '';
                            obj.promoSpotTitle = obj.rowHeaderTitle ?? '';
                            obj.carouselContentType = 'promo_hub';
                            obj.rowHeaderTitle =
                                this.element
                                    .querySelector('h2.video-section-title')
                                    ?.innerText?.trim() ?? '';
                        }

                        if (obj.carouselPresentationStyle === 'spotlight') {
                            obj = appendSpotlightTracking(
                                $(this.element).closest('.spotlight-carousel'),
                                obj,
                            );
                        }

                        obj.posRowNum = this.getCurrentPageRowPosition();
                        // START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
                        //store this tile's movieContentId /showId into the local storage
                        //then sends to PHP store in cookie
                        const prevSearchInstance = initializePreviousSearchInstance();
                        if (prevSearchInstance) {
                            obj = trackRecentSearchCarousel(obj);
                        }
                        // END A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
                        trackAction(action, obj);
                    }
                });
            });
        }
    }
    __getPreSearchSuggestionFilters() {
        let preSearchCategories = document.querySelectorAll('.presearch-category');
        let searchFilters = [];

        preSearchCategories.forEach((elem) => {
            if (elem.hasAttribute('data-category')) {
                // Add this suggestion tab in view for tracking
                searchFilters.push(elem.getAttribute('data-category'));
            }
        });
        return searchFilters;
    }
}
